import Editor from "@monaco-editor/react"

export default function TextContent(props:{text:string,onChange:(text:string|undefined) => void}){
    return <Editor defaultValue={props.text} onChange={props.onChange}/>
}